module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"MALE":"Male","FEMELLE":"Female","HONGRE":"Gelding","INCONNU":"Unknown"}}')
  delete Component.options._Ctor
}
